import React, { useMemo, useState } from "react";
import FormField from "./FormField";
import { useDispatch, useSelector } from "react-redux";
import { setForm2Options } from "../../../../../services/slices/addformSlice";
import { Button, Grid } from "@mui/material";
import FlightShopSettings from "../flight-shop-settings";
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import { historyOptions } from "../../../../../utils/constants/constants";
import "./stepTwo.scss";
import { useLocation } from "react-router-dom";

const StepTwo = ({ setActiveStep, initialData }) => {
    const dispatch = useDispatch()
    const location = useLocation();
    const { state } = location;
    const { form2Options } = useSelector(state => state?.addShop);
    const [formData, setFormData] = useState(initialData);
    const [error, setError] = useState({})
    const posOptions = useSelector(state => state?.timezone?.timezone?.pos);
    const currencyOptions = useSelector(state => state?.timezone?.timezone?.currency);
    const stopOptions = useSelector(state => state?.timezone?.timezone?.stops);
    const durationOptions = useSelector(state => state?.timezone?.timezone?.durations);

    // Set values selected/inserted in shop form
    const handleChange = (e) => {
        const { name, value } = e.target;
        const numValue = Number(value);
        const isInvalid = numValue < 1 || numValue > 5;
        const isInvalidDay = numValue < 0 || numValue > 365;

        if (["adults", "infants"].includes(name) && isInvalid) {
            if (value === "") {
                setFormData(prev => ({ ...prev, [name]: "" }));
                dispatch(setForm2Options({ ...formData, [name]: "" }));
                setError(prev => ({ ...prev, adults: "" }));
                return;
            }
            setError(prev => ({ ...prev, adults: isInvalid ? `Please enter a valid number between 1-5` : "" }));
        } else if (["startDay", "endDay"].includes(name) && isInvalidDay) {
        } else if (name === "customDay") {
            const splitChunks = (str, chunkSize = 2) => {
                const result = [];
                for (let i = 0; i < str.length; i += chunkSize) {
                    result.push(str.slice(i, i + chunkSize));
                }
                return result;
            };
            const sanitizedValue = value.replace(/^,+/g, '').replace(/,+/g, ',');
            const result = sanitizedValue
                ?.split(',')
                ?.map(v => v.replace(/^0+(?=\d)/, ''))
                ?.flatMap((val, idx, arr) => {
                    if (val === "" && idx === arr.length - 1) {
                        return [val];
                    }
                    if (val === "") {
                        return [];
                    }
                    const num = Number(val);
                    return num > 365 ? splitChunks(val, 2) : [val];
                })
                ?.join(',');
            setFormData(prevData => ({ ...prevData, [name]: result }));
            dispatch(setForm2Options({ ...formData, [name]: result }))
        } else if (name === "los") {
            const sanitizedValue = value.replace(/[^0-9,]/g, '');
            setFormData(prevData => ({ ...prevData, [name]: sanitizedValue }));
            dispatch(setForm2Options({ ...formData, [name]: sanitizedValue }));
            if (sanitizedValue) {
                setError((prev) => ({ ...prev, [name]: "", route: "" }));
            }
        } else if (name === "history" && !value?.length) {
            setFormData(prevData => ({ ...prevData, [name]: value, historicalHorizon: null }));
            dispatch(setForm2Options({ ...formData, [name]: value, historicalHorizon: null }))
            if (value) {
                setError((prev) => ({ ...prev, [name]: "" }));
            }
        } else if (name === "route" && value === "OW") {
            setFormData(prevData => ({ ...prevData, [name]: value, "los": null }));
            dispatch(setForm2Options({ ...formData, [name]: value, "los": null }))
            setError((prev) => ({ ...prev, "route": "" }));

        } else {
            setFormData(prevData => ({ ...prevData, [name]: value }));
            dispatch(setForm2Options({ ...formData, [name]: value }))
            if (value) {
                setError((prev) => ({ ...prev, [name]: "" }));
            }
        }
    };

    const handleClear = () => {
        setFormData(initialData);
    };

    const routeOptions = [
        { label: "OW", value: "OW" }, // One Way
        { label: "RT", value: "RT" }  // Round Trip
    ];

    const cabinOptions = [
        { label: "Economy", value: "Economy" },
        { label: "Business", value: "Business" },
        { label: "First Class", value: "First Class" },
        { label: "Premium Economy", value: "Premium Economy" },
    ];
    const daysOutFieldsConfig = [
        {
            id: "startDay",
            label: "Horizon Start Day",
            name: "startDay",
            type: "number",
        }, {
            id: "endDay",
            label: "Horizon End Day",
            name: "endDay",
            type: "number",
        },
    ]

    const fixedFieldsConfig = [
        {
            id: "startDate",
            label: "Horizon Start Date",
            name: "startDate",
            minDate: !state?.editFlightshop ? new Date().toISOString().split('T')[0] : null,
            type: "date",
        }, {
            id: "endDate",
            label: "Horizon End Date",
            name: "endDate",
            minDate: form2Options?.startDate ? form2Options.startDate : new Date().toISOString().split('T')[0],
            maxDate: new Date(new Date(form2Options?.startDate || new Date()).setDate(new Date(form2Options?.startDate || new Date()).getDate() + 365)).toISOString().split('T')[0],
            type: "date",
        },
    ]
    const customFieldsConfig = [
        {

            id: "customDay",
            label: "Specific Custom Horizon Days",
            name: "customDay",
            type: "text",
        }
    ]


    const historicalFieldsConfig = useMemo(() => {
        let config = [
            {
                id: "history",
                label: "",
                name: "history",
                type: "checkbox",
                options: [{ label: "Add Historical Data To This Shop To See The Price Evolution In The Past", value: "yes" }],
                ClassNames: "checkbox-input rate-parity-label",
                fullGrid: true
            }
        ]
        if (formData.history?.includes("yes")) { // Show input when "RT" is selected
            config.push(
                {
                    id: "historicalHorizon",
                    label: "Price Evolution Horizon",
                    name: "historicalHorizon",
                    type: "select",
                    value: formData.historicalHorizon,
                    options: parseInt(formData.historicalHorizon) > 60 ? [...historyOptions.map(data => ({ label: data, value: data })), { label: parseInt(formData.historicalHorizon), value: parseInt(formData.historicalHorizon) }] : historyOptions.map(data => ({ label: data, value: data })),
                    disabled: parseInt(formData.historicalHorizon) > 60
                })
        }
        return config
        // eslint-disable-next-line
    }, [formData?.history])

    // Dynamically update fieldsConfig based on selected "route"
    const fieldsConfig = useMemo(() => {
        let config = [
            {
                id: "route",
                label: "Route Type",
                name: "route",
                type: "radio",
                options: routeOptions,
                ClassNames: "checkbox-input"
            },
            {
                id: "cabinClass",
                label: "Cabin Class",
                name: "cabinClass",
                type: "radio",
                options: cabinOptions,
                ClassNames: "checkbox-input"
            },
            {
                id: "adults",
                label: "Adults",
                name: "adults",
                type: "number",
                max: 5
            },
            {
                id: "infants",
                label: "Infants",
                name: "infants",
                type: "number",
                max: 5
            },
            {
                id: "pos",
                label: "POS",
                name: "pos",
                type: "select",
                options: posOptions?.map(data => ({ label: data?.country, value: data?.country })),
                ClassNames: "checkbox-input"
            },
            {
                id: "currency",
                label: "Currency",
                name: "currency",
                type: "select",
                options: currencyOptions?.map(data => ({ label: data?.iso, value: data?.iso })),
                ClassNames: "checkbox-input"
            },
            {
                id: "maxStops",
                label: "Max Stops",
                name: "maxStops",
                type: "select",
                options: stopOptions?.map(data => ({ label: data?.stop, value: data?.stop })),
                ClassNames: "checkbox-input"
            },
            {
                id: "maxDuration",
                label: "Max Duration (hours)",
                name: "maxDuration",
                type: "select",
                options: durationOptions?.map(data => ({ label: data?.duration, value: data?.duration })),
                ClassNames: "checkbox-input"
            },

        ];
        if (formData.route === "RT") { // Show input when "RT" is selected
            config = [
                ...config.slice(0, 1),  // First two elements (route & cabinClass)
                {
                    id: "los",
                    label: "LOS",
                    name: "los",
                    type: "text",
                    placeholder: "",
                    ClassNames: "los-flex",
                    helperText: "Enter only positive whole numbers and use commas for multiple values, for example: 1,7,14."
                },
                ...config.slice(1) // Remaining elements after the 2nd index
            ];
        }
        return config;
        // eslint-disable-next-line
    }, [formData.route]); // Update when route changes

    const handleSubmit = (e) => {
        e.preventDefault();
        let hasError = false; // Flag to track if there are any errors

        // Resetting errors initially
        setError({});

        // Checking each required field and setting errors if missing
        if (!formData.route) {
            setError((prev) => ({ ...prev, route: "Route Type is required" }));
            hasError = true; // Set flag to true if there's an error
        } else if (formData.route === "RT" && !formData.los) {
            setError((prev) => ({ ...prev, route: "Length of stay is invalid" }));
            hasError = true; // Set flag to true if there's an error
        } else if (formData.route === "RT" && formData.los) {
            const hasDuplicates = (str) => {
                const items = str.toString().split(',').filter(i => i.trim() !== "");
                const set = new Set(items);
                return set.size !== items.length;
            };
            const hasZero = (str) => {
                const items = str.toString().split(',').filter(i => i.trim() !== "");
                return items.some(item => Number(item) === 0);
            };
            if (hasZero(formData.los)) {
                setError((prev) => ({ ...prev, route: "Length of stay is invalid" }));
                hasError = true;
            } else if (hasDuplicates(formData.los)) {
                setError((prev) => ({ ...prev, route: "Please remove duplicate values in Length of stay" }));
                hasError = true; // Set flag to true if there's an error
            }
        }

        if (!formData?.cabinClass) {
            setError((prev) => ({ ...prev, cabinClass: "Cabin Class is required" }));
            hasError = true; // Set flag to true if there's an error
        }
        if (!formData?.adults || formData?.adults < 1) {
            setError((prev) => ({ ...prev, adults: "Number of Adults is required" }));
            hasError = true; // Set flag to true if there's an error
        }
        if (!formData?.pos) {
            setError((prev) => ({ ...prev, pos: "POS is required" }));
            hasError = true; // Set flag to true if there's an error
        }
        if (!formData?.currency) {
            setError((prev) => ({ ...prev, currency: "Currency is required" }));
            hasError = true; // Set flag to true if there's an error
        }
        if (!formData?.maxStops) {
            setError((prev) => ({ ...prev, maxStops: "Stop is required" }));
            hasError = true; // Set flag to true if there's an error
        }
        if (!formData?.maxDuration) {
            setError((prev) => ({ ...prev, maxDuration: "Duration is required" }));
            hasError = true; // Set flag to true if there's an error
        }
        if (!formData?.horizonDays?.length && !formData?.startDate && !formData?.endDate && !formData?.customDay) {
            setError((prev) => ({ ...prev, horizon: "Please select at least one horizon option" }));
            hasError = true; // Set flag to true if there's an error
        }
        if (!formData?.horizonDays?.length && formData?.startDate && !formData?.endDate) {
            setError((prev) => ({ ...prev, endDate: "Please Enter Horizon End Date" }));
            hasError = true; // Set flag to true if there's an error
        } else if (!formData?.horizonDays?.length && !formData?.startDate && formData?.endDate) {
            setError((prev) => ({ ...prev, startDate: "Please Enter Horizon Start Date" }));
            hasError = true; // Set flag to true if there's an error

        }
        if (formData?.history !== null && formData?.history?.includes("yes") && !formData.historicalHorizon > 0) {
            setError((prev) => ({ ...prev, historicalHorizon: "Price evolution is required" }));
            hasError = true; // Set flag to true if there's an error

        }
        if (formData?.customDay && formData?.customDay !== null && formData?.customDay !== "") {
            const hasDuplicates = (str) => {
                const items = str.split(',');
                const set = new Set(items);
                return set.size !== items.length;
            };
            if (hasDuplicates(formData?.customDay)) {
                setError((prev) => ({ ...prev, customDay: "Please remove duplicate values" }));
                hasError = true; // Set flag to true if there's an error
            }
        }
        // If there are no errors, proceed to setActiveStep(2)
        if (!hasError) {
            setActiveStep(2);
        }
    };

    const handleHorizon = (e) => {
        e.preventDefault();
        if (formData?.startDay === "" || formData?.startDay === undefined || formData?.startDay === null || !formData?.endDay || (formData?.startDay === formData?.endDay)) {
            setError((prev) => ({ ...prev, startDay: "Please select horizon end day greater than horizon startday" }))
        } else if (formData?.horizonDays.includes(`${formData?.startDay}-${formData?.endDay}`)) {
            setError((prev) => ({ ...prev, startDay: "Horizon for same start and end day already exists" }))
        } else if (parseInt(formData?.startDay) > parseInt(formData?.endDay)) {
            setError((prev) => ({ ...prev, startDay: "Please select horizon end day greater than horizon startday" }))
        } else {
            setFormData(prev => ({ ...prev, horizonDays: [...prev?.horizonDays, `${formData?.startDay}-${formData?.endDay}`], startDay: null, endDay: null }))
            dispatch(setForm2Options({ ...formData, horizonDays: [...formData?.horizonDays, `${formData?.startDay}-${formData?.endDay}`], startDay: null, endDay: null }))

            setError((prev) => ({ ...prev, horizon: "", startDay: "" }));
        }
    }

    const handleHorizonDelete = (e, data) => {
        e.preventDefault()
        setFormData(prev => ({ ...prev, horizonDays: prev.horizonDays?.filter(dt => dt !== data), startDay: null, endDay: null }))
        dispatch(setForm2Options({ ...formData, horizonDays: formData.horizonDays?.filter(dt => dt !== data), startDay: null, endDay: null }))

    }
    return (
        <>
            <form onSubmit={handleSubmit} className="second-stepper second-stepper-horizon">
                <Grid container columns={{ xs: 4, sm: 6, md: 12 }} >
                    <Grid item xs={7} >
                        <FormField
                            formData={formData}
                            handleChange={handleChange}
                            cancelOnClick={handleClear}
                            setFormData={setFormData}
                            fieldsConfig={fieldsConfig}
                            errorMessage={error}

                        />
                    </Grid>
                    <Grid item xs={4}>
                        <FlightShopSettings activeStep={1} />
                    </Grid>


                </Grid >
                <Grid container columns={{ xs: 4, sm: 6, md: 12 }} >
                    <Grid item xs={12} >
                        <h4 className="horizon-heading ">Horizons setup section</h4>
                        {error["horizon"] ? <span className="err-txt">{error["horizon"]}</span> : ""}
                        <div className="box-horizon">
                            <Grid container columns={{ xs: 4, sm: 6, md: 12 }} >
                                <Grid item xs={6} >
                                    <h5 className="horizon-subheading">Days Out Horizon</h5>
                                </Grid>
                                <Grid item xs={6}>
                                    <div className="infoicon-info">
                                        <InfoRoundedIcon />
                                        <p className="infoicon-info-para">Add the days out ranges for which you want to see the prices</p>
                                    </div>
                                </Grid>
                                <Grid item xs={6} >
                                    <FormField
                                        formData={formData}
                                        handleChange={handleChange}
                                        cancelOnClick={handleClear}
                                        setFormData={setFormData}
                                        fieldsConfig={daysOutFieldsConfig}
                                        errorMessage={error}
                                        insideSplit={true}
                                        addBtn={true}
                                        addAction={handleHorizon}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <ol className="days-selection mt-5 mb-5">
                                        {formData?.horizonDays?.length > 0 &&
                                            formData?.horizonDays?.map((i, index) => (
                                                <li key={index}>
                                                    {index + 1}. {`Horizon days From ${i.split('-')[0]} to ${i.split('-')[1]}`}
                                                    <Button onClick={(e) => handleHorizonDelete(e, i)}>
                                                        Delete
                                                    </Button>
                                                </li>
                                            ))}
                                    </ol>
                                </Grid>
                            </Grid>
                        </div>
                        <div className="box-horizon">
                            <Grid container columns={{ xs: 4, sm: 6, md: 12 }} >
                                <Grid item xs={6} >
                                    <h5 className="horizon-subheading">Fixed Days Horizons</h5>
                                </Grid>
                                <Grid item xs={6}>
                                    <div className="infoicon-info">
                                        <InfoRoundedIcon />
                                        <p className="infoicon-info-para">Fill this field if you want to add a fixed window of dates to your horizons</p>
                                    </div>
                                </Grid>
                                <Grid item xs={6} >
                                    <FormField
                                        formData={formData}
                                        handleChange={handleChange}
                                        cancelOnClick={handleClear}
                                        setFormData={setFormData}
                                        fieldsConfig={fixedFieldsConfig}
                                        errorMessage={error}
                                        insideSplit={true}
                                    />
                                </Grid>
                            </Grid>

                        </div>
                        <div className="box-horizon">
                            <Grid container columns={{ xs: 4, sm: 6, md: 12 }} >
                                <Grid item xs={6} >
                                    <h5 className="horizon-subheading">Custom Horizon</h5>
                                </Grid>
                                <Grid item xs={6}>
                                    <div className="infoicon-info">
                                        <InfoRoundedIcon />
                                        <p className="infoicon-info-para">Fill this field only if you want to extract specific days</p>
                                    </div>
                                </Grid>
                                <Grid item xs={6}>
                                    <FormField
                                        formData={formData}
                                        handleChange={handleChange}
                                        cancelOnClick={handleClear}
                                        setFormData={setFormData}
                                        fieldsConfig={customFieldsConfig}
                                        errorMessage={error}
                                        insideSplit={true}
                                    />
                                </Grid>
                            </Grid>

                        </div>
                        <div className="box-horizon mb-15">
                            <Grid container columns={{ xs: 4, sm: 6, md: 12 }} >
                                <Grid item xs={6} >
                                    <h5 className="horizon-subheading">Historical Data</h5>
                                </Grid>
                                <Grid item xs={6}>
                                    <div className="infoicon-info">
                                        <InfoRoundedIcon />
                                        <p className="infoicon-info-para">Select the number of days in the past to be analyzed for historical trends analysis</p>
                                    </div>
                                </Grid>
                                <Grid item xs={6}>
                                    <FormField
                                        formData={formData}
                                        handleChange={handleChange}
                                        cancelOnClick={handleClear}
                                        setFormData={setFormData}
                                        fieldsConfig={historicalFieldsConfig}
                                        errorMessage={error}
                                        insideSplit={true}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                    </Grid>
                </Grid>
                <div className="stepper-btn no-translate">
                    <button type="button" className="secondary_button clear-background" onClick={() => setActiveStep(0)}>Previous - Choose Flight Attributes</button><br />
                    <button type="submit" className="secondary_button stepper-next-btn">Next - Schedule & Frequency</button>
                </div>
            </form>

        </>
    );
};

export default StepTwo;

